<template>
  <a-form layout="vertical">
    <a-row :gutter="12">
      <a-col :span="12">
        <a-form-item label="Desde">
          <a-date-picker
            v-model:value="from"
            style="width: 100%"
            :format="humanDateFormat"
            valueFormat="YYYY-MM-DD"
            @change="handleChange"
          />
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item label="Hasta">
          <a-date-picker
            v-model:value="to"
            style="width: 100%"
            :format="humanDateFormat"
            valueFormat="YYYY-MM-DD"
            @change="handleChange"
          />
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { humanDateFormat } from "@/app/shared/utils/constants";

export default {
  props: {
    value: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      humanDateFormat,
      from: this.value[0],
      to: this.value[1],
    };
  },
  methods: {
    handleChange() {
      // this.value[index] = dateToString(value)
      console.log({ from: this.from, to: this.to });
      const values = [this.from, this.to];
      const haveTwoDates = !values.some((date) => date === null);

      this.$emit("update:value", values);
      this.$emit("change", haveTwoDates);
    },
  },
};
</script>

<style lang="sass" scoped>
.text
  padding: 12px 24px
  margin: 0

  &--bold
    color: $gray-9
    font-weight: 600

.ant-form-item
  margin-bottom: 4px
</style>
